import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() title = '';
  @Output() goBackEv = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  backAction() {
    this.goBackEv.emit();
  }
}
